import { Operation } from '../../../__generated__/globalTypes'

import { Amount, amountString } from '../../fragments/__generated__/Amount'

import getCreditsBalanceRawString from '../GetCreditsBalance.graphql'

const getCreditsBalanceString = [getCreditsBalanceRawString, amountString].join(
  '\n\n',
)

export type GetCreditsBalanceData = {
  account: {
    credits: Amount
  }
}

export type GetCreditsBalance = Operation<GetCreditsBalanceData>

export const GetCreditsBalance = (): GetCreditsBalance => ({
  query: getCreditsBalanceString,
  variables: undefined,
})
